module.exports = __webpack_public_path__ + "media/images/components/landing_pages/reassurance_cards/efficient@3x-a60f62253a5a55d95ece252f9b1c6fa7.png";